export default __webpack_public_path__ + "static/media/elexio-community@3x.9bb0500c.png";